import { render } from "./DocusignDocumentList.vue?vue&type=template&id=0128de15&ts=true"
import script from "./DocusignDocumentList.vue?vue&type=script&lang=ts"
export * from "./DocusignDocumentList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__